/* es-quick v2 2026-10-10: ricerca catalogo, lista, carrello diretto, preventivo al modulo OS. */
(function(){
  var root=document.querySelector('.esq'); if(!root||root.dataset.on) return; root.dataset.on='1';
  var T=JSON.parse(root.querySelector('[data-esq-t]').textContent);
  var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var CUR=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||root.dataset.currency||'EUR';
  var LOC=document.documentElement.lang||root.dataset.lang||'it';
  var KEY='esq_righe', MAXR=60;
  var QMAX=10, TMAX=100000; // soglie preventivo: 10 pezzi dello stesso articolo o 1.000 euro (centesimi, IVA inclusa)
  var $=function(s,el){ return (el||root).querySelector(s); };
  var rowsEl=$('[data-rows]'), msg=$('[data-msg]');
  var rows=[];

  function money(c){ try{ return new Intl.NumberFormat(LOC,{style:'currency',currency:CUR}).format(c/100); }catch(e){ return (c/100).toFixed(2)+' '+CUR; } }
  function num(n){ try{ return new Intl.NumberFormat(LOC).format(n); }catch(e){ return String(n); } }
  function say(el,t,err){ el.hidden=!t; el.textContent=t||''; el.className='esq__msg'+(err?' is-err':''); }
  function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':String(s); return d.innerHTML; }
  function img(u,w){ if(!u) return ''; u=String(u); if(u.indexOf('//')===0) u='https:'+u; return u+(u.indexOf('?')<0?'?':'&')+'width='+w; }
  function getJSON(u){ return fetch(u,{headers:{Accept:'application/json'}}).then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); }); }
  function suggest(q,n){
    return getJSON(R+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]='+(n||7)+'&resources[options][unavailable_products]=last&resources[options][fields]=title,variants.sku,vendor,product_type,tag')
      .then(function(j){ return (j.resources&&j.resources.results&&j.resources.results.products)||[]; });
  }
  function product(h){ return getJSON(R+'products/'+encodeURIComponent(h)+'.js'); }

  // contatore articoli: numero reale da Shopify, formattato e animato
  var cnt=$('[data-n]'), N=parseInt(cnt.dataset.n,10)||0, sin=$('.esq__sin');
  sin.placeholder=window.innerWidth<500?T.ph:sin.dataset.ph.replace('[n]',num(N));
  if(N){
    var still=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(still||!('IntersectionObserver' in window)) cnt.textContent=num(N);
    else { cnt.textContent='0'; var t0=null; var step=function(t){ if(!t0) t0=t; var k=Math.min(1,(t-t0)/1400), e=1-Math.pow(1-k,3); cnt.textContent=num(Math.round(N*e)); if(k<1) requestAnimationFrame(step); }; requestAnimationFrame(step); }
  } else cnt.parentNode.hidden=true;

  // ricerca con suggerimenti: usata nell'apertura e nel "Cambia" di ogni riga
  function attach(inp,ul,onPick,onFree){
    var timer, seq=0, items=[], on=-1;
    function close(){ ul.hidden=true; inp.setAttribute('aria-expanded','false'); on=-1; }
    function hl(i){ on=i; [].forEach.call(ul.children,function(li,j){ li.classList.toggle('is-on',j===i); if(j===i&&li.scrollIntoView) li.scrollIntoView({block:'nearest'}); }); }
    function draw(list,q){
      items=list; ul.innerHTML='';
      list.forEach(function(p){
        var li=document.createElement('li'); li.setAttribute('role','option');
        li.innerHTML=(p.image?'<img src="'+esc(img(p.image,120))+'" alt="" loading="lazy">':'<span class="esq__ph"></span>')+'<span class="t">'+esc(p.title)+'</span><span class="p">'+(p.price?esc(money(Math.round(parseFloat(p.price)*100))):'')+'</span>';
        li.onmousedown=function(e){ e.preventDefault(); close(); onPick(p.handle,q); };
        ul.appendChild(li);
      });
      if(!list.length){ var x=document.createElement('li'); x.className='x'; x.textContent=T.none; ul.appendChild(x); }
      var f=document.createElement('li'); f.className='free'; f.textContent=T.use_free+': '+q;
      f.onmousedown=function(e){ e.preventDefault(); close(); onFree(q); };
      ul.appendChild(f);
      ul.hidden=false; inp.setAttribute('aria-expanded','true'); on=-1;
    }
    function run(){
      clearTimeout(timer); var q=inp.value.trim();
      if(q.length<2){ close(); return; }
      timer=setTimeout(function(){
        var my=++seq; ul.innerHTML='<li class="x">'+esc(T.searching)+'</li>'; ul.hidden=false;
        suggest(q).then(function(list){ if(my===seq) draw(list,q); }).catch(function(){ if(my===seq) draw([],q); });
      },200);
    }
    inp.addEventListener('input',run);
    inp.addEventListener('focus',function(){ if(inp.value.trim().length>=2&&ul.hidden) run(); });
    inp.addEventListener('keydown',function(e){
      var n=ul.children.length;
      if(e.key==='ArrowDown'&&!ul.hidden){ e.preventDefault(); hl((on+1)%n); }
      else if(e.key==='ArrowUp'&&!ul.hidden){ e.preventDefault(); hl((on-1+n)%n); }
      else if(e.key==='Escape') close();
      else if(e.key==='Enter'){
        e.preventDefault(); var q=inp.value.trim(); if(!q) return;
        var li=on>=0&&ul.children[on];
        close();
        if(li&&li.className.indexOf('free')>=0) onFree(q);
        else if(on>=0&&on<items.length) onPick(items[on].handle,q);
        else if(items.length) onPick(items[0].handle,q);
        else suggest(q,1).then(function(l){ l.length?onPick(l[0].handle,q):onFree(q); }).catch(function(){ onFree(q); });
      }
    });
    inp.addEventListener('blur',function(){ setTimeout(close,150); });
    return {run:run};
  }

  var hero=attach(sin,$('[data-hero-search] .esq__sug'),
    function(h,q){ var r=addRow(); if(!r) return; pick(r,h,q).then(function(){ flash(r); }); sin.value=''; },
    function(q){ var r=addRow(); if(!r) return; freeMode(r,q); flash(r); sin.value=''; });
  var q0=new URLSearchParams(location.search).get('q'); if(q0){ sin.value=q0.slice(0,80); setTimeout(function(){ sin.focus({preventScroll:true}); hero.run(); },300); }
  root.querySelectorAll('.esq__chip').forEach(function(c){ c.onclick=function(){ sin.value=c.dataset.q; sin.focus(); hero.run(); }; });

  function save(){
    try{ localStorage.setItem(KEY,JSON.stringify(rows.filter(function(r){return r.kind;}).map(function(r){ return r.kind==='cat'?{k:'c',h:r.handle,v:r.vid,q:r.qty}:{k:'f',c:r.code,b:r.brand,q:r.qty}; }))); }catch(e){}
  }
  function cur(r){ return r.variants&&r.variants.filter(function(v){return v.id===r.vid;})[0]; }
  function sumUp(){
    var t=0, any=false, pcs=0, n=0;
    rows.forEach(function(r){ if(!r.kind) return; n++; pcs+=r.qty; var v=r.kind==='cat'&&cur(r); if(v&&v.available){ t+=v.price*r.qty; any=true; } });
    $('[data-total]').textContent=any?money(t):'-';
    // carrello o preventivo: articoli fuori catalogo o esauriti, oppure quantita' alte, spingono il preventivo
    var okN=0, other=0, big=false;
    rows.forEach(function(r){ if(!r.kind) return; var v=r.kind==='cat'&&cur(r); if(v&&v.available) okN++; else other++; if(r.qty>=QMAX) big=true; });
    if(t>=TMAX) big=true;
    var quote=other>0||big, cb=$('[data-cart]'), qb=$('[data-quote]');
    $('[data-acts]').classList.toggle('is-quote',quote);
    cb.classList.toggle('esq__btn--line',quote); qb.classList.toggle('esq__btn--line',!quote);
    $('[data-cart-lbl]').textContent=other>0&&okN>0?T.cart_avail.replace('[n]',okN):T.cart;
    $('[data-act-cart]').hidden=n>0&&okN===0;
    $('[data-volhint]').hidden=!(big&&other===0);
    $('[data-lines]').textContent=num(n); $('[data-pcs]').textContent=num(pcs);
    var bd=$('[data-badge]'); bd.hidden=!n; bd.textContent=n;
    $('[data-empty]').hidden=rows.length>0; $('[data-clear]').hidden=!rows.length;
    root.classList.toggle('has-items',rows.length>0); $('[data-share]').hidden=!n;
    save();
  }
  function flash(r){ r.el.classList.remove('is-new'); void r.el.offsetWidth; r.el.classList.add('is-new'); }

  function addRow(init){
    if(rows.length>=MAXR) return null;
    var r={qty:1}; rows.push(r);
    var el=document.createElement('div'); el.className='esq__row'; r.el=el;
    el.innerHTML='<div class="esq__item"><div class="esq__pick"><span class="esq__ph"></span><div class="t"><span class="esq__meta">'+esc(T.searching)+'</span></div></div></div><div class="esq__qty"><button type="button" aria-label="-">&minus;</button><input type="number" min="1" max="9999" value="1" inputmode="numeric" aria-label="'+esc(T.h_qty)+'"><button type="button" aria-label="+">+</button></div><div class="esq__price"></div><button type="button" class="esq__rm" aria-label="'+esc(T.remove)+'"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    var qIn=el.querySelector('.esq__qty input'), bs=el.querySelectorAll('.esq__qty button');
    function setQ(n){ n=Math.max(1,Math.min(9999,parseInt(n,10)||1)); r.qty=n; qIn.value=n; paintPrice(r); sumUp(); }
    r.setQ=setQ;
    bs[0].onclick=function(){ setQ(r.qty-1); }; bs[1].onclick=function(){ setQ(r.qty+1); };
    qIn.addEventListener('change',function(){ setQ(qIn.value); });
    el.querySelector('.esq__rm').onclick=function(){ rows.splice(rows.indexOf(r),1); el.remove(); sumUp(); };
    rowsEl.insertBefore(el,rowsEl.firstChild);
    if(init&&init.qty) setQ(init.qty); else sumUp();
    return r;
  }
  function paintPrice(r){
    var p=r.el.querySelector('.esq__price'), v=r.kind==='cat'&&cur(r);
    p.innerHTML=v&&v.available?esc(money(v.price*r.qty))+(r.qty>1?'<small>'+esc(money(v.price))+'</small>':''):(r.kind?'<span class="q">'+esc(T.quote)+'</span>':'');
  }
  function rowSearch(r,val){
    var box=r.el.querySelector('.esq__item');
    box.innerHTML='<input type="text" class="esq__in" autocomplete="off" spellcheck="false" role="combobox" aria-expanded="false" aria-autocomplete="list" placeholder="'+esc(T.ph)+'"><ul class="esq__sug" role="listbox" hidden></ul>';
    var inp=box.querySelector('input'); if(val) inp.value=val;
    attach(inp,box.querySelector('ul'),function(h,q){ pick(r,h,q); },function(q){ freeMode(r,q); });
    inp.focus(); if(val) inp.select();
  }
  function pick(r,handle,q,vid){
    return product(handle).then(function(p){
      r.kind='cat'; r.handle=p.handle; r.title=p.title; r.img=p.featured_image; r.variants=p.variants||[];
      var ql=(q||'').toLowerCase(), bySku=r.variants.filter(function(v){ return v.sku&&v.sku.toLowerCase()===ql; })[0];
      var byId=vid&&r.variants.filter(function(v){ return v.id===vid; })[0];
      var first=r.variants.filter(function(v){return v.available;})[0]||r.variants[0];
      r.vid=(byId||bySku||first||{}).id;
      paintPick(r); paintPrice(r); sumUp();
    }).catch(function(){ freeMode(r,q||handle); });
  }
  function paintPick(r){
    var box=r.el.querySelector('.esq__item'), many=r.variants.length>1;
    box.innerHTML='<div class="esq__pick">'+(r.img?'<img src="'+esc(img(r.img,180))+'" alt="" loading="lazy">':'<span class="esq__ph"></span>')+'<div class="t"><a href="'+esc(R+'products/'+r.handle)+'" target="_blank" rel="noopener">'+esc(r.title)+'</a><div class="esq__meta"></div>'+(many?'<select class="esq__var" aria-label="'+esc(T.variant)+'"></select>':'')+'</div></div>';
    var meta=box.querySelector('.esq__meta');
    function info(){
      var v=cur(r)||{};
      meta.innerHTML=(v.sku?'<span class="esq__tag">'+esc(v.sku)+'</span>':'')+(v.available?'':'<span class="esq__tag is-warn">'+esc(T.oos)+'</span>')+'<button type="button" class="esq__chg">'+esc(T.change)+'</button>';
      meta.querySelector('.esq__chg').onclick=function(){ rowSearch(r); };
    }
    info();
    if(many){
      var s=box.querySelector('select');
      r.variants.forEach(function(x){ var o=document.createElement('option'); o.value=x.id; o.textContent=x.title+(x.available?'':' ('+T.oos.split(':')[0]+')'); if(x.id===r.vid) o.selected=true; s.appendChild(o); });
      s.onchange=function(){ r.vid=parseInt(s.value,10); info(); paintPrice(r); sumUp(); };
    }
  }
  function freeMode(r,q,brand){
    r.kind='free'; r.code=q; r.brand=brand||''; r.variants=null; r.vid=null;
    var box=r.el.querySelector('.esq__item');
    box.innerHTML='<div class="esq__pick"><span class="esq__ph is-free">?</span><div class="t"><b></b><div class="esq__meta"><span class="esq__tag is-warn">'+esc(T.nocat)+'</span><button type="button" class="esq__chg">'+esc(T.change)+'</button></div><input type="text" class="esq__brand" maxlength="60" placeholder="'+esc(T.brand)+'"></div></div>';
    box.querySelector('b').textContent=q;
    var b=box.querySelector('.esq__brand'); b.value=r.brand; b.oninput=function(){ r.brand=b.value.trim(); save(); };
    box.querySelector('.esq__chg').onclick=function(){ rowSearch(r,r.code); };
    paintPrice(r); sumUp();
  }

  // incolla una lista: "codice o nome  quantita" per riga, cercati uno alla volta
  var pasteBox=$('[data-paste]'), pasteTa=$('textarea',pasteBox), pasteGo=$('[data-paste-go]');
  $('[data-paste-open]').onclick=function(){ pasteBox.hidden=!pasteBox.hidden; if(!pasteBox.hidden) pasteTa.focus(); };
  pasteGo.onclick=function(){
    var lines=pasteTa.value.split(/\r?\n/).map(function(l){return l.trim();}).filter(Boolean).slice(0,MAXR);
    if(!lines.length) return;
    pasteGo.disabled=true; say(msg,T.paste_busy);
    var chain=Promise.resolve();
    lines.reverse().forEach(function(l){
      var m=l.match(/^(.*?)[\s;,\t]+(?:x\s*)?(\d{1,4})\s*(?:pz|pcs|stk|st)?\.?$/i), q=m?m[1].trim():l, n=m?parseInt(m[2],10):1;
      if(!q) return;
      chain=chain.then(function(){
        var r=addRow({qty:n}); if(!r) return;
        return suggest(q,1).then(function(list){ return list.length?pick(r,list[0].handle,q):freeMode(r,q); }).catch(function(){ freeMode(r,q); });
      });
    });
    chain.then(function(){ pasteGo.disabled=false; pasteTa.value=''; pasteBox.hidden=true; say(msg,''); });
  };
  $('[data-clear]').onclick=function(){ rows.forEach(function(r){ r.el.remove(); }); rows=[]; sumUp(); say(msg,''); };

  // carrello: solo gli articoli a catalogo disponibili; il resto resta in lista per il preventivo
  var cartBtn=$('[data-cart]');
  cartBtn.onclick=function(){
    say(msg,'');
    var ok=rows.filter(function(r){ var v=r.kind==='cat'&&cur(r); return v&&v.available; });
    var rest=rows.filter(function(r){ return r.kind&&ok.indexOf(r)<0; });
    if(!ok.length){ say(msg,rest.length?T.cart_skip:T.empty,true); if(!rest.length) sin.focus(); return; }
    cartBtn.disabled=true;
    fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:ok.map(function(r){ return {id:r.vid,quantity:r.qty}; })})})
      .then(function(res){ if(!res.ok) throw new Error(res.status); return res.json(); })
      .then(function(){
        ok.forEach(function(r){ rows.splice(rows.indexOf(r),1); r.el.remove(); });
        sumUp();
        if(rest.length){ cartBtn.disabled=false; say(msg,T.cart_skip); document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }
        else window.location.href=R+'cart';
      })
      .catch(function(){ cartBtn.disabled=false; say(msg,T.cart_err,true); });
  };

  // preventivo: pannello laterale con riepilogo e dati del cliente
  var drawer=$('[data-drawer]'), form=$('[data-form]'), fmsg=$('[data-fmsg]'), send=$('.esq__send'), lastFocus=null;
  document.body.appendChild(drawer);
  function openD(){
    lastFocus=document.activeElement;
    var list=rows.filter(function(r){return r.kind;});
    $('[data-mini]',drawer).innerHTML='<ul>'+list.map(function(r){ var v=r.kind==='cat'&&cur(r)||{}; return '<li><span>'+esc(r.kind==='cat'?r.title+(r.variants.length>1&&v.title?' / '+v.title:''):r.code)+'</span><span>x '+r.qty+'</span></li>'; }).join('')+'</ul>';
    drawer.hidden=false; document.documentElement.classList.add('esq-lock');
    requestAnimationFrame(function(){ drawer.classList.add('is-open'); });
    setTimeout(function(){ var n=form.querySelector('[name="nome"]'); if(n&&!form.classList.contains('is-done')) n.focus(); },360);
  }
  function closeD(){
    drawer.classList.remove('is-open'); document.documentElement.classList.remove('esq-lock');
    setTimeout(function(){ drawer.hidden=true; if(lastFocus&&lastFocus.focus) lastFocus.focus(); },350);
  }
  drawer.querySelectorAll('[data-close]').forEach(function(x){ x.onclick=closeD; });

  // privato o azienda: l'azienda da' i dati di fatturazione; in Italia codice univoco o PEC,
  // nel resto dell'UE la P.IVA si controlla sul VIES (passando dall'OS: il VIES non accetta il browser)
  var fatt=$('[data-fatt]',drawer), viesEl=$('[data-vies]',drawer);
  var UE='AT BE BG CY CZ DE DK EE ES FI FR GR HR HU IE LT LU LV MT NL PL PT RO SE SI SK XI'.split(' ');
  var vies={key:'',p:null};
  function az(){ var x=form.querySelector('[name="tipo_cliente"]:checked'); return !!x&&x.value==='azienda'; }
  function iso(){ return form.paese_iso.value; }
  function viesSay(t,cls){ viesEl.hidden=!t; viesEl.textContent=t||''; viesEl.className='esq__vies'+(cls?' '+cls:''); }
  function viesPaint(j){
    if(!j||j.stato==='fuori_vies') viesSay('');
    else if(j.stato==='valida') viesSay(T.v_ok+(j.nome?': '+j.nome:''),'is-ok');
    else if(j.stato==='non_valida') viesSay(T.v_ko,'is-err');
    else viesSay(T.v_na);
  }
  function checkVies(){
    var pv=form.piva.value.trim(), c=iso();
    if(!az()||c==='IT'||UE.indexOf(c)<0||pv.replace(/[^A-Za-z0-9]/g,'').length<4){ vies={key:'',p:null}; viesSay(''); return Promise.resolve(null); }
    var key=c+'|'+pv; if(vies.key===key&&vies.p) return vies.p;
    viesSay(T.v_check);
    var my={key:key}; vies=my;
    my.p=fetch(root.dataset.endpoint+'vies',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({paese:c,piva:pv})})
      .then(function(r){ return r.json(); }).catch(function(){ return {stato:'non_verificabile'}; })
      .then(function(j){ if(!j||!j.stato) j={stato:'non_verificabile'}; if(vies===my) viesPaint(j); return j; });
    return my.p;
  }
  function paintFatt(){
    var a=az(), it=iso()==='IT';
    fatt.hidden=!a;
    fatt.querySelectorAll('[data-it]').forEach(function(x){ x.hidden=!it; });
    var zona=it?'it':(UE.indexOf(iso())>=0?'ue':'extra');
    fatt.querySelectorAll('[data-zona]').forEach(function(x){ x.hidden=x.dataset.zona!==zona; });
    form.piva.closest('.esq__f').classList.toggle('esq__full',!it);
    checkVies();
  }
  form.querySelectorAll('[name="tipo_cliente"]').forEach(function(x){ x.onchange=paintFatt; });
  form.paese_iso.addEventListener('change',paintFatt);
  form.piva.addEventListener('change',checkVies);
  form.piva.addEventListener('blur',checkVies);
  form.addEventListener('input',function(e){ if(!fmsg.hidden) say(fmsg,''); var f=e.target.closest&&e.target.closest('.esq__f'); if(f) f.classList.remove('is-miss'); if(e.target.name==='sdi'||e.target.name==='pec') fatt.querySelectorAll('[name=sdi],[name=pec]').forEach(function(x){ x.closest('.esq__f').classList.remove('is-miss'); }); });
  paintFatt();
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!drawer.hidden) closeD(); });
  $('[data-quote]').onclick=function(){
    say(msg,'');
    if(!rows.some(function(r){return r.kind;})){ say(msg,T.empty,true); sin.focus(); return; }
    openD();
  };
  function testo(note){
    var list=rows.filter(function(r){return r.kind;}).slice().reverse(), out=['Articoli richiesti ('+list.length+'):'];
    list.forEach(function(r,i){
      if(r.kind==='cat'){
        var v=cur(r)||{}, many=r.variants.length>1;
        out.push((i+1)+'. '+r.title+(many&&v.title?' ['+v.title+']':'')+(v.sku?' | cod. '+v.sku:'')+' | q.ta '+r.qty+(v.price?' | '+money(v.price)+' cad. sul sito':'')+(v.available?'':' | su ordinazione')+' | easysea.org/products/'+r.handle);
      } else out.push((i+1)+'. DA QUOTARE (non a catalogo): '+r.code+(r.brand?' | marca '+r.brand:'')+' | q.ta '+r.qty);
    });
    var s=out.join('\n'); if(note) s+='\n\nNote del cliente:\n'+note;
    return s.slice(0,2990);
  }
  form.addEventListener('submit',function(e){
    e.preventDefault(); say(fmsg,'');
    var d={}; [].forEach.call(form.elements,function(x){ if(x.name&&x.type!=='checkbox'&&(x.type!=='radio'||x.checked)) d[x.name]=x.value.trim(); });
    var EM=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, a=az(), it=iso()==='IT';
    if(!d.nome||!d.cognome||!EM.test(d.email)||!form.consenso.checked){ say(fmsg,T.req,true); return; }
    // azienda: i dati di fatturazione sono obbligatori, i campi mancanti si colorano e il cursore va sul primo
    fatt.querySelectorAll('.is-miss').forEach(function(x){ x.classList.remove('is-miss'); });
    if(a){
      var miss=['azienda','piva','indirizzo','cap','citta'].filter(function(k){ return !d[k]; });
      if(it&&!/^[A-Za-z0-9]{7}$/.test(d.sdi)&&!EM.test(d.pec)) miss.push('sdi','pec');
      if(miss.length){
        miss.forEach(function(k){ fatt.querySelector('[name="'+k+'"]').closest('.esq__f').classList.add('is-miss'); });
        say(fmsg,miss[0]==='sdi'?T.req_sdi:T.req_az,true);
        var first=fatt.querySelector('[name="'+miss[0]+'"]'); first.scrollIntoView({block:'center',behavior:'smooth'}); setTimeout(function(){ first.focus({preventScroll:true}); },50);
        return;
      }
    }
    if(!rows.some(function(r){return r.kind;})){ say(fmsg,T.empty,true); return; }
    send.disabled=true; send.textContent=T.sending;
    var po=form.paese_iso.options[form.paese_iso.selectedIndex];
    var campi={nome:d.nome,cognome:d.cognome,email:d.email,telefono:d.telefono,paese:po?po.text:'',attivita:d.attivita,reparto:'Preventivo veloce (ordine rapido)',messaggio:testo(d.note),tipo_cliente:a?'azienda':'privato'};
    // righe strutturate e note: l'OS ci scrive il riepilogo per il cliente nella sua lingua
    campi.note=d.note;
    campi.righe=rows.filter(function(r){return r.kind;}).slice().reverse().map(function(r){
      if(r.kind!=='cat') return {t:r.code,q:r.qty,libero:true,marca:r.brand||''};
      var v=cur(r)||{}; return {t:r.title,sku:v.sku||'',v:r.variants.length>1?(v.title||''):'',q:r.qty};
    });
    if(a){
      campi.azienda=d.azienda; campi.piva=d.piva; campi.indirizzo=d.indirizzo; campi.cap=d.cap; campi.citta=d.citta; campi.paese_iso=d.paese_iso;
      if(it){ campi.cf=d.cf; campi.provincia=d.provincia.toUpperCase(); campi.sdi=d.sdi.toUpperCase(); campi.pec=d.pec; }
    }
    checkVies().then(function(j){
      if(j&&j.stato==='non_valida'){ send.disabled=false; send.textContent=T.send; say(fmsg,T.v_ko,true); form.piva.focus(); return; }
      return inviaModulo(campi);
    });
  });
  function inviaModulo(campi){
    return fetch(root.dataset.endpoint+'invio',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({modulo:'preventivo',lingua:root.dataset.lang,pagina:location.pathname,trappola:form.trappola.value,campi:campi})})
      .then(function(res){ return res.json().catch(function(){return {};}).then(function(j){ if(!res.ok) throw new Error(j.errore||''); return j; }); })
      .then(function(j){
        form.querySelector('[data-done]').textContent=T.ok+(j.numero?' '+j.numero:'');
        form.classList.add('is-done');
        window.dataLayer=window.dataLayer||[]; window.dataLayer.push({event:'form_submit',form:'preventivo_veloce',righe:rows.filter(function(r){return r.kind;}).length});
        rows.forEach(function(r){ r.el.remove(); }); rows=[]; sumUp();
        try{ localStorage.removeItem(KEY); }catch(e){}
      })
      .catch(function(err){ send.disabled=false; send.textContent=T.send; say(fmsg,err&&err.message?err.message:T.err,true); });
  }

  // lista da condividere: ?add=handle:qta:variante,... e ?lib=codice~marca~qta,... per gli articoli non a catalogo
  function listaUrl(){
    var cat=[], lib=[];
    rows.forEach(function(r){
      if(r.kind==='cat') cat.push(r.handle+':'+r.qty+(r.vid?':'+r.vid:''));
      else if(r.kind==='free') lib.push([r.code,r.brand||'',r.qty].map(function(x){ return encodeURIComponent(String(x).replace(/[~,]/g,' ')); }).join('~'));
    });
    return location.origin+location.pathname+'?'+(cat.length?'add='+cat.join(','):'')+(cat.length&&lib.length?'&':'')+(lib.length?'lib='+lib.join(','):'');
  }
  var shareMsg=$('[data-share-msg]');
  function shareSay(t){ shareMsg.textContent=t||''; if(t) setTimeout(function(){ if(shareMsg.textContent===t) shareMsg.textContent=''; },5000); }
  $('[data-link]').onclick=function(){
    var u=listaUrl();
    var ok=function(){ shareSay(T.link_ok); window.dataLayer=window.dataLayer||[]; window.dataLayer.push({event:'quick_list_link'}); };
    if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(u).then(ok,function(){ window.prompt('',u); });
    else window.prompt('',u);
  };
  function script(src){ return new Promise(function(ok,ko){ var s=document.createElement('script'); s.src=src; s.onload=ok; s.onerror=ko; document.head.appendChild(s); }); }
  function dataImg(u,w){
    return new Promise(function(ok){
      if(!u){ ok(null); return; }
      var im=new Image(); im.crossOrigin='anonymous'; var done=false; var t=setTimeout(function(){ if(!done){ done=true; ok(null); } },6000);
      im.onload=function(){ if(done) return; done=true; clearTimeout(t); try{ var c=document.createElement('canvas'), k=w/Math.max(im.width,im.height); c.width=Math.round(im.width*k); c.height=Math.round(im.height*k); var x=c.getContext('2d'); x.fillStyle='#fff'; x.fillRect(0,0,c.width,c.height); x.drawImage(im,0,0,c.width,c.height); ok({d:c.toDataURL('image/jpeg',.85),w:c.width,h:c.height}); }catch(e){ ok(null); } };
      im.onerror=function(){ if(!done){ done=true; clearTimeout(t); ok(null); } };
      im.src=u;
    });
  }
  var pdfBtn=$('[data-pdf]');
  pdfBtn.onclick=function(){
    var list=rows.filter(function(r){return r.kind;}); if(!list.length) return;
    pdfBtn.disabled=true; shareSay(T.pdf_busy);
    var jp=window.jspdf?Promise.resolve():script('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js').then(function(){ return script('https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js'); });
    jp.then(function(){
      return Promise.all([dataImg(root.dataset.logo,700)].concat(list.map(function(r){ return dataImg(r.kind==='cat'&&r.img?img(r.img,240):null,160); })));
    }).then(function(ims){
      var logo=ims[0], thumbs=ims.slice(1), doc=new window.jspdf.jsPDF({unit:'mm',format:'a4'}), W=210, M=15;
      var clean=function(s){ return String(s).replace(/[\u00a0\u202f]/g,' '); };
      var oggi=new Date().toLocaleDateString(LOC,{day:'2-digit',month:'2-digit',year:'numeric'});
      if(logo) doc.addImage(logo.d,'JPEG',M,14,34,34*logo.h/logo.w);
      doc.setFont('helvetica','bold'); doc.setFontSize(20); doc.setTextColor(4,6,3); doc.text(T.pdf_title,W-M,20,{align:'right'});
      doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(91,98,112); doc.text(oggi+'  ·  easysea.org',W-M,26,{align:'right'});
      doc.setDrawColor(227,230,236); doc.line(M,32,W-M,32);
      var tot=0, any=false, body=list.map(function(r){
        if(r.kind==='cat'){
          var v=cur(r)||{}, many=r.variants.length>1, ok=v.available&&v.price!=null;
          if(ok){ tot+=v.price*r.qty; any=true; }
          return ['',r.title+(many&&v.title?'\n'+v.title:'')+(v.sku?'\n'+v.sku:''),String(r.qty),ok?clean(money(v.price)):'-',ok?clean(money(v.price*r.qty)):T.pdf_quote];
        }
        return ['',r.code+(r.brand?'\n'+r.brand:''),String(r.qty),'-',T.pdf_quote];
      });
      doc.autoTable({startY:38,margin:{left:M,right:M},head:[['',T.pdf_item,T.pdf_qty,T.pdf_unit,T.pdf_tot]],body:body,theme:'plain',
        styles:{font:'helvetica',fontSize:9.5,textColor:[4,6,3],cellPadding:{top:3,bottom:3,left:2,right:2},valign:'middle',minCellHeight:16},
        headStyles:{fillColor:[0,71,186],textColor:255,fontStyle:'bold',minCellHeight:8},
        columnStyles:{0:{cellWidth:18},2:{cellWidth:16,halign:'center'},3:{cellWidth:28,halign:'right'},4:{cellWidth:30,halign:'right',fontStyle:'bold'}},
        didParseCell:function(h){ if(h.section==='body') h.cell.styles.lineColor=[227,230,236], h.cell.styles.lineWidth={bottom:.2}; },
        didDrawCell:function(h){ if(h.section==='body'&&h.column.index===0){ var t=thumbs[h.row.index]; if(t){ var s=12, k=Math.min(s/t.w,s/t.h)*1; doc.addImage(t.d,'JPEG',h.cell.x+2+(s-t.w*k)/2,h.cell.y+2+(s-t.h*k)/2,t.w*k,t.h*k); } } }
      });
      var y=doc.lastAutoTable.finalY+8;
      if(y>250){ doc.addPage(); y=20; }
      doc.setDrawColor(4,6,3); doc.setLineWidth(.5); doc.line(W-M-80,y,W-M,y);
      doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(91,98,112); doc.text(T.pdf_total,W-M-80,y+6);
      doc.setFont('helvetica','bold'); doc.setFontSize(18); doc.setTextColor(4,6,3); doc.text(any?clean(money(tot)):'-',W-M,y+14,{align:'right'});
      y+=26; doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor(91,98,112);
      var note=doc.splitTextToSize(T.pdf_note.replace('[d]',oggi)+' '+T.pdf_ask,W-2*M); doc.text(note,M,y); y+=note.length*4.5+4;
      doc.setTextColor(0,71,186); doc.setFont('helvetica','bold'); doc.textWithLink(T.pdf_reopen+' >',M,y,{url:listaUrl()});
      var pages=doc.getNumberOfPages();
      for(var i=1;i<=pages;i++){ doc.setPage(i); doc.setFont('helvetica','normal'); doc.setFontSize(8); doc.setTextColor(123,130,144); doc.text('EASYSEA S.R.L.  ·  easysea.org',M,287); doc.text(i+' / '+pages,W-M,287,{align:'right'}); }
      doc.save('easysea-lista-'+new Date().toISOString().slice(0,10)+'.pdf');
      shareSay(''); window.dataLayer=window.dataLayer||[]; window.dataLayer.push({event:'quick_list_pdf',righe:list.length});
    }).catch(function(){ shareSay(T.err); }).then(function(){ pdfBtn.disabled=false; });
  };

  // avvio: righe da link (?add=handle:qta:variante,... e ?lib=...) oppure dalla bozza salvata
  var start=[], qs=new URLSearchParams(location.search);
  var add=qs.get('add'), lib=qs.get('lib');
  if(add||lib){
    if(add) add.split(',').slice(0,MAXR).forEach(function(x){ var p=x.split(':'); if(p[0]) start.push({k:'c',h:p[0],q:parseInt(p[1],10)||1,v:parseInt(p[2],10)||undefined}); });
    if(lib) lib.split(',').slice(0,MAXR).forEach(function(x){ var p=x.split('~').map(function(y){ try{ return decodeURIComponent(y); }catch(e){ return y; } }); if(p[0]) start.push({k:'f',c:p[0].slice(0,80),b:(p[1]||'').slice(0,60),q:parseInt(p[2],10)||1}); });
  }
  else { try{ start=JSON.parse(localStorage.getItem(KEY)||'[]')||[]; }catch(e){ start=[]; } }
  var chain=Promise.resolve();
  start.reverse().forEach(function(s){
    chain=chain.then(function(){ var r=addRow({qty:s.q}); if(!r) return; return s.k==='c'?pick(r,s.h,'',s.v):freeMode(r,s.c,s.b); });
  });
  sumUp();
})();
